import { makeStyles } from "@material-ui/core";

const useRbCheckboxStyles = makeStyles(() => ({
  root: {
    width: 32,
    height: 32,
    padding: 0,
  },
}));

export default useRbCheckboxStyles;
